<div [formGroup]="form">
  <!-- Manage Pharmacys start -->
  <section class="manage-pharmacy">
    <p id="{{ baseId }}-import-subtitle" translate>
      Import Clearinghouse Pharmacies into the Practice Pharmacies List</p>
    <!-- Area Codes Control -->
    <div class="form-group">
      <label for="{{ baseId }}-area-codes" translate>Area Codes (ex:408, 504)</label>
      <input id="{{ baseId }}-area-codes" class="form-control"
        [ngClass]="{
          error: showErrors(areaCodesControl, isSubmitted),
          warning: form.warnings?.areaCodes && !form.disabled,
          'required': isRequired(areaCodesControl)
        }"
        type="text" [maxlength]="fcListValidation.validations.AreaCodes.MaxLength" formControlName="areaCodes" />
      <div *ngIf="showErrors(areaCodesControl, isSubmitted)" id="{{ baseId }}-warning-text-area-codes"
        class="incorrect-input" translate>
        {{ areaCodesControl.errors | fcListValidation : 'AreaCodes' }}
      </div>
      <div *ngIf="form.warnings?.areaCodes && !form.disabled"
        id="{{ baseId }}-warning-text-address" class="warning-message">
        {{ form.warnings | fcListValidation : 'AreaCodes' }}
        <br>
      </div>
    </div>
    <!-- Area Codes  Control -->

    <!-- ZIP Codes Control -->
    <div class="form-group">
      <label for="{{ baseId }}-zip-codes" translate>ZIP Codes (ex: 10000, 99999)</label>
      <input id="{{ baseId }}-zip-codes" class="form-control"
        [ngClass]="{
          error: showErrors(zipCodesControl, isSubmitted),
          warning: form.warnings?.zipCodes && !form.disabled,
          'required': isRequired(zipCodesControl)
        }"
        type="text" [maxlength]="fcListValidation.validations.ZipCodes.MaxLength" formControlName="zipCodes" />
      <div *ngIf="showErrors(zipCodesControl, isSubmitted)" id="{{ baseId }}-warning-text-zip-codes"
        class="incorrect-input" translate>
        {{ zipCodesControl.errors | fcListValidation : 'ZipCodes' }}
      </div>
      <div *ngIf="form.warnings?.zipCodes && !form.disabled"
        id="{{ baseId }}-warning-text-address" class="warning-message">
        {{ form.warnings | fcListValidation : 'ZipCodes' }}
      </div>
    </div>
    <!-- ZIP Codes  Control -->

    <!-- Pharmacy IDs Control -->
    <div class="form-group">
      <label for="{{ baseId }}-pharmacy-ids" translate>Pharmacy IDs (NCPDPID)</label>
      <input id="{{ baseId }}-pharmacy-ids" class="form-control"
        [ngClass]="{
          error: showErrors(pharmacyIdsControl, isSubmitted),
          warning: form.warnings?.pharmacyIds && !form.disabled,
          'required': isRequired(pharmacyIdsControl)
        }"
        type="text" [maxlength]="fcListValidation.validations.PharmacyIds.MaxLength" formControlName="pharmacyIds" />
      <div *ngIf="showErrors(pharmacyIdsControl, isSubmitted)" 333 id="{{ baseId }}-warning-text-pharmacy-ids"
        class="incorrect-input" translate>
        {{ pharmacyIdsControl.errors | fcListValidation : 'PharmacyIds' }}
      </div>
      <div *ngIf="form.warnings?.pharmacyIds && !form.disabled"
        id="{{ baseId }}-warning-text-address" class="warning-message">
        {{ form.warnings | fcListValidation : 'PharmacyIds' }}
      </div>
    </div>
    <!-- Pharmacy IDs  Control -->

    <!-- Checkboxes -->
    <div class="checkbox-group">
      <mat-checkbox id="{{ baseId }}-import-mail-order-pharmacies-checkbox" formControlName="importMailOrderPharmacies"
        translate>
        Import Mail Order Pharmacies </mat-checkbox>
      <mat-checkbox id="{{ baseId }}-disable-ePrescribe-for-fax-only-pharmacies-checkbox"
        formControlName="disableEPrescribe" translate>
        Disable ePrescribe For Fax Only Pharmacies</mat-checkbox>
    </div>
    <!-- Checkboxes -->

    <!-- Import Button -->
    <button class="btn btn-light btn-flush-left execute-pharmacy-btn" type="button" [disabled]="!disableImportButton()"
      (click)="executePharmacyImport()">Execute Pharmacy
      Import</button>
    <!-- Import Button -->
  </section>
  <!-- Manage Pharmacys end -->
</div>
